<template>
    <div id="message_list">
        <div class="message_list">
            <div class="message_list1">
                <div class="message_list2">消息通知</div>
                <div class="message_list3">
                    <div class="cursor_1" :class="titleIndex == i ? 'message_list4 message_list5' : 'message_list4'"
                        v-for="(item, i) in title" :key="i" @click="select(i, item.category)">
                        {{ item.name }}
                    </div>
                </div>
            </div>

            <div class="message_list7" v-if="list.length == 0">
                <noData></noData>
            </div>
            <div class="message_list7" ref="scrollContainer" v-else>
                <div v-for="(item, i) in list" :key="i" @click="toDetail(item.id)">
                    <div class="message_list8" v-if="!item.icon">
                        <div class="message_list9">
                            <div class="message_list10">{{ item.title }}</div>
                            <div class="message_list11 cursor_1">点击查看></div>
                        </div>
                        <div class="message_list12">{{ item.uploadedTime }}</div>
                    </div>
                    <div class="message_imgText" v-else>
                        <img :src="item.icon" width="250" height="120"
                            style="object-fit: cover;aspect-ratio:16/9;border-radius: 8px;flex-shrink: 0;" />
                        <div class="message_text">
                            <p class="title">{{ item.title }}</p>
                            <p class="introduction t-m-t-10 u-line-1">{{ item.introduction }}</p>
                            <p class="time">{{ item.uploadedTime }}<span
                                    class="message_list11 cursor_1 t-m-l-10">点击查看></span></p>
                        </div>
                    </div>
                </div>
                <div ref="loader" class="loader">
                    <div v-if="loading">加载中...</div>
                    <div v-if="!hasMore">没有更多数据了</div>
                </div>
            </div>
        </div>
        <bottomPage v-show="total" :total="total" @currentNUm="currentNUm" :pageSize="pageSize" ref="bottompage">
        </bottomPage>
    </div>
</template>
<script>
import api from '@/api/api';
import { EventBus } from '@/utils/eventBus'
import noData from './no_data.vue';
import bottomPage from '../components/bottom_page.vue' //底部分页
import { scrollerMixin } from '@/mixin/scrollerMixin';
export default {
    mixins: [scrollerMixin],
    components: {
        noData, bottomPage
    },
    data() {
        return {
            title: [],
            titleIndex: 0,
            type: '',
            list: [],
            total: 0,
            pageNum: 1,
            pageSize: 16,
        }
    },
    created() {
        this.type = this.$route.query.type || ''
        console.log('this.type=', this.type)
        if (this.type) {
            this.getDynamics(false)
        } else {
            this.getDynamics(true)
        }
        this.getUserLoginState(false)
    },
    watch: {
        // 监听 list 变化，数据加载完成后初始化观察器
        list() {
            this.$nextTick().then(() => {
                this.initObserver({
                    scrollRequest: () => {
                        this.loadItems()
                    }
                })
            })
        }
    },
    methods: {
        //获取分类列表
        getDynamics(init) {
            console.log('分类传入init=', init)
            api.getDynamics().then((res) => {
                // console.log(res)
                if (res.code == 200) {
                    res.data.map((item) => {
                        let items = {}
                        items.name = item.name
                        items.category = item.category
                        this.title.push(items)
                    })
                    if (this.title.length > 0 && init) {
                        this.type = this.title[0].category
                        this.loadItems()
                    }
                    if (this.title.length > 0 && !init) {
                        this.titleIndex = this.title.findIndex(item => item.category == this.type) || 0
                        console.log('获取分类索引=', this.titleIndex)
                        this.loadItems()
                    }

                }
            })
        },
        async loadItems() {
            this.loading = true;
            try {
                const response = await api.getDynamicsList(this.type, { pageNum: this.pageNum });
                console.log('response=', response)
                if (response.code === 200) {
                    this.list = [...this.list, ...response.data];
                    this.pageNum++;
                    this.hasMore = response.data.length >= 16;
                } else {
                    this.$message.warning(response.msg)
                }

            } catch (error) {
                console.error('滚动分页出现问题:', error);
            } finally {
                this.loading = false;
            }
        },
        // getDynamicsList(type) {
        //     api.getDynamicsList(type, { pageNum: this.pageNum, pageSize: this.pageSize }).then((res) => {
        //         if (res.code == 200) {
        //             this.list = res.rows
        //             this.total = res.total
        //         }
        //     })
        // },
        //切换标题
        select(i, category) {
            if (this.titleIndex === i) return
            this.titleIndex = i
            this.list = []
            this.pageNum = 1
            this.type = category
            this.loadItems()
        },
        //去详情
        toDetail(id) {
             if (this.loginState) {
                EventBus.$emit('openLogin')
                return 
            }
            this.$emit('toDetail', id)
        },
        currentNUm(pageNum) {
            this.pageNum = pageNum
            let item = this.title.find((_, i) => i === this.titleIndex)
            console.log('item=', item)
            if (item) {
                this.getDynamicsList(item.category)
            }

            //分页记录缓存
            // let key = this.getChapterSearchKey(this.nChapterSearchKey, this.novelInfo.id)
            // localStorage.setItem(key, JSON.stringify({ pageNum }))
            // this.getChapterList(this.novelInfo)
        },
    }
}
</script>
<style scoped>
#message_list {
    flex: 1;
    height: 100%;
    padding: 16px 0 0 20px;
    display: flex;
    flex-direction: column;
}

.message_list {
    flex: 1;
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-bottom: 15px;
    border-radius: 10px;
}

.message_list1 {
    padding: 20px;
    border-bottom: 1px solid #E6EBF0;
}

.message_list2 {
    font-weight: bold;
    font-size: 18px;
    color: #0B0B0B;
    margin-bottom: 15px;
}

.message_list3 {
    display: flex;
}

.message_list4 {
    min-width: 92px;
    padding: 0 10px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 16px;
    color: #666666;
    background: #F8F8F8;
    border-radius: 6px;
    margin-right: 20px;
    position: relative;
}

.message_list5 {
    color: var(--tech-primary);
    background: var(--tech-btn-Lightblue);
}

.message_list6 {
    position: absolute;
    top: 3px;
    right: 3px;
    width: 8px;
    height: 8px;
    background: #FF3030;
    border-radius: 8px;
}

.message_list7 {
    width: 100%;
    height: calc(100% - 116px);
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding: 0 20px;
}

.message_list8 {
    display: flex;
    align-items: center;
    height: 65px;
    line-height: 65px;
    border-bottom: 1px solid #E6EBF0;
    justify-content: space-between;
}

.message_imgText {
    display: flex;
    /* align-items: center; */
    padding: 10px 0;
    border-bottom: 1px solid #E6EBF0;
}

.message_text {
    width: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px 0;
    margin-left: 20px;
}

.message_text p {
    margin: 0;
    padding: 0;
}

.message_imgText .title {
    font-size: 18px;
    color: #0B0B0B;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 10px;
}

.message_imgText .introduction {
    font-size: 15px;
    color: #666;
}

.message_imgText .time {
    font-size: 15px;
    color: #666666;
}

.message_list9 {
    display: flex;
}

.message_list10 {
    max-width: 600px;
    font-size: 18px;
    color: #0B0B0B;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 10px;
}

.message_list11 {
    font-size: 15px;
    color: var(--tech-primary);
}

.message_list12 {
    font-size: 15px;
    color: #666666;
}

.loader {
    font-size: 16px !important;
}
</style>